// src/queries/pages/dashboard/onboardingApiConfig.js

/**
 * ONBOARDING API CONFIGURATION
 * Keys map to pms-api (NestJS) endpoints via next.config rewrites
 */
export const onboardingConfig = {
  getInvite: {
    key: "getInvite",
    url: (token) => `/api/v1/user-invites/${token}`,
    method: "GET",
    options: {
      retry: 1,
      meta: { description: "Fetch invite information by token" },
    },
  },

  acceptInvite: {
    key: "acceptInvite",
    url: (data) => `/api/v1/user-invites/${data.token || data}/accept`,
    method: "POST",
    options: {
      retry: 2,
      onSuccessMessage: "Invite accepted successfully",
      onErrorMessage: "Failed to accept invite",
      meta: { description: "Accept user invite and complete onboarding" },
    },
  },

  validateRegistrationInvite: {
    key: "validateRegistrationInvite",
    url: (token) => `/api/v1/user-invites/${token}/validate-registration`,
    method: "GET",
    options: {
      retry: 1,
      meta: { description: "Validate hotel owner invite token for registration" },
    },
  },

  createRegistrationFromInvite: {
    key: "createRegistrationFromInvite",
    url: "/api/v1/registrations/from-invite",
    method: "POST",
    options: {
      retry: 2,
      onSuccessMessage: "Registration submitted successfully",
      onErrorMessage: "Failed to submit registration",
      meta: { description: "Submit hotel owner registration from invite" },
    },
  },
};
